'use client';

import { Icon } from '@benzinga/core-ui';
import * as icons from './Icons';
import styled from '@benzinga/themetron';
import { IconDefinition } from '@fortawesome/pro-light-svg-icons';

export type SocialButtonName = keyof typeof icons;

export interface SocialButtonProps {
  icon: IconDefinition | SocialButtonName;
  url: string;
  key: string;
  className?: string;
}
export const SocialButton = ({ className, icon, url }: SocialButtonProps) => (
  <LinkBox className={className} href={url} rel="noopener noreferrer" target="_blank">
    {typeof icon === 'string' ? icons[icon] : <Icon icon={icon} />}
  </LinkBox>
);

const LinkBox = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 4px;
  background-color: ${props => props.theme.colorPalette.gray100};
  color: ${props => props.theme.colorPalette.gray500};
  transition:
    0.25s background-color ease-in-out,
    0.25s color ease-in-out;

  &:hover {
    background-color: rgba(26, 121, 255, 0.1);
    color: ${props => props.theme.colorPalette.blue500};
  }
`;

export interface SocialButtonsProps {
  buttons: Array<SocialButtonProps>;
  className?: string;
}

export const SocialButtons = ({ buttons, className }: SocialButtonsProps) => (
  <ButtonsBox className={className}>
    {buttons.map(data => (
      <SocialButton icon={data.icon} key={data.key} url={data.url} />
    ))}
  </ButtonsBox>
);

const ButtonsBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;
